import type { QueryClient } from '@tanstack/react-query';

/**
 * Query prefixes whose data can change when a Shopify store is synced.
 * Keeping this list in one place prevents a successful Settings or Products
 * refresh from leaving the Insights cards on their old five-minute cache.
 */
const SHOPIFY_DATA_QUERY_PREFIXES = new Set([
  'analytics-dashboard',
  'campaign-shopify-commerce',
  'insights',
  'order-journey',
  'revenue-by-channel',
  'shopify-access-scopes',
  'shopify-connection',
  'shopify-commerce-kpis',
  'shopify-last-recorded-sale',
  'shopify-order-history-sync',
  'shopify-products',
  'shopify-store-sync',
  'shopify-storefront-funnel',
  'shopify-top-selling-products',
]);

export function invalidateShopifyDataQueries(queryClient: QueryClient): Promise<void> {
  return queryClient.invalidateQueries({
    predicate: (query) => {
      const prefix = query.queryKey[0];
      return typeof prefix === 'string' && SHOPIFY_DATA_QUERY_PREFIXES.has(prefix);
    },
  });
}
